import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<div\n  class=\"fc-draggable-wrapper cLIB--createPostBtnWrapper\"\n  data-media-item-id=\"text\"\n  {{draggable\n    onDragStart=this.onDragStart\n    onDragEnd=this.onDragEnd\n    isFullCalendarDraggable=true\n    isDisabled=this.isCalendarSelectMode\n  }}\n>\n  <Shared::Ui::Button\n    @additional=\"block\"\n    @class=\"cLIB--createPostBtn eLib--boardItem ui-draggable qa--calendar__create_text_post_button at--testImgTour__createPostBtn--top at--createPostTour__createPostBtn--top at--testImgTour__createPostBtn--bottom\"\n    @onClick={{this.handleCreatePost}}\n    @size=\"large\"\n    @variant=\"primary\"\n    data-test-id=\"create-post-button\"\n  >\n    <span class=\"cLIB--createPostBtn__itemWrapper u--p__r\">\n      {{svg-jar \"media-add\" class=\"o--icon o--icon--md u--m__r__sm cLIB--createPostBtn__icon--left\"}}\n      {{t \"calendar.side_library.create_post\"}}\n    </span>\n    {{svg-jar \"draggable\" class=\"o--icon cLIB--createPostBtn__icon--right\"}}\n  </Shared::Ui::Button>\n</div>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<div\n  class=\"fc-draggable-wrapper cLIB--createPostBtnWrapper\"\n  data-media-item-id=\"text\"\n  {{draggable\n    onDragStart=this.onDragStart\n    onDragEnd=this.onDragEnd\n    isFullCalendarDraggable=true\n    isDisabled=this.isCalendarSelectMode\n  }}\n>\n  <Shared::Ui::Button\n    @additional=\"block\"\n    @class=\"cLIB--createPostBtn eLib--boardItem ui-draggable qa--calendar__create_text_post_button at--testImgTour__createPostBtn--top at--createPostTour__createPostBtn--top at--testImgTour__createPostBtn--bottom\"\n    @onClick={{this.handleCreatePost}}\n    @size=\"large\"\n    @variant=\"primary\"\n    data-test-id=\"create-post-button\"\n  >\n    <span class=\"cLIB--createPostBtn__itemWrapper u--p__r\">\n      {{svg-jar \"media-add\" class=\"o--icon o--icon--md u--m__r__sm cLIB--createPostBtn__icon--left\"}}\n      {{t \"calendar.side_library.create_post\"}}\n    </span>\n    {{svg-jar \"draggable\" class=\"o--icon cLIB--createPostBtn__icon--right\"}}\n  </Shared::Ui::Button>\n</div>","moduleName":"later/components/media-items/create-post-button.hbs","parseOptions":{"srcName":"later/components/media-items/create-post-button.hbs"}});
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import moment from 'moment';

import { CALENDAR_TYPES, TEXT_POST_TYPE, ProfilePostType } from 'later/utils/constants';

import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';
import type MediaItemModel from 'later/models/media-item';
import type ConfigService from 'later/services/calendar/config';
import type SegmentService from 'later/services/segment';
import type SelectedSocialProfilesService from 'later/services/selected-social-profiles';
import type { Maybe } from 'shared/types';
import type { SocialPlatformType } from 'shared/types/social-profile';

const { SELECT } = CALENDAR_TYPES;

interface CreatePostButtonComponentArgs {
  selectedAssets: MediaItemModel[];
  scheduleMultiImagePost: (mediaItems: MediaItemModel[], location: string) => void;
  onDragEnd: (dragEvent: DragEvent) => void;
  onDragStart: (dragEvent: DragEvent) => void;
}

export default class CreatePostButtonComponent extends Component<CreatePostButtonComponentArgs> {
  @service('calendar/config') declare calendarConfig: ConfigService;
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare selectedSocialProfiles: SelectedSocialProfilesService;
  @service declare segment: SegmentService;

  dragImage: Maybe<HTMLElement>;

  mediaAddSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="#BBCBDA">
    <g clip-path="url(#clip0)">
      <path fill-rule="evenodd" d="M9.273 6.727c-2.01 0-3.546 1.536-3.546 3.545 0 2.01 1.537 3.546 3.546 3.546s3.545-1.537 3.545-3.546-1.536-3.545-3.545-3.545zm0 4.727c-.71 0-1.182-.473-1.182-1.182s.473-1.181 1.182-1.181 1.182.472 1.182 1.181c0 .71-.473 1.182-1.182 1.182z" clip-rule="evenodd"/>
      <path d="M22.063 1C21.476 1 21 1.475 21 2.062v2.813h-2.875a1.125 1.125 0 000 2.25H21v2.812a1.062 1.062 0 102.125 0V7.125h2.75a1.125 1.125 0 000-2.25h-2.75V2.062A1.063 1.063 0 0022.063 1z"/>
      <path fill-rule="evenodd" d="M26.758 21.241l-1.767 1.768-5.882-5.881-9.49 9.491-1.768-1.768L19.11 13.593l7.648 7.648z" clip-rule="evenodd"/>
      <path fill-rule="evenodd" d="M25.818 14c-.709 0-1.182.473-1.182 1.182v8.273c0 .709-.472 1.182-1.181 1.182H4.545c-.709 0-1.181-.473-1.181-1.182V4.545c0-.709.472-1.181 1.182-1.181h8.272c.71 0 1.182-.473 1.182-1.182C14 1.472 13.527 1 12.818 1H4.546C2.536 1 1 2.536 1 4.546v18.909C1 25.464 2.536 27 4.546 27h18.909C25.464 27 27 25.464 27 23.455v-8.273c0-.71-.473-1.182-1.182-1.182z" clip-rule="evenodd"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0h28v28H0z"/>
      </clipPath>
    </defs>
  </svg>`;

  get isCalendarSelectMode(): boolean {
    return this.calendarConfig.calendarType === SELECT;
  }

  get socialProfilesSelectedForScheduling(): SocialPlatformType[] {
    return this.selectedSocialProfiles.profiles.map((profile) => profile.accountType);
  }

  @action
  handleCreatePost(): void {
    if (this.args.selectedAssets?.length > 0) {
      this.args.scheduleMultiImagePost(this.args.selectedAssets, 'clicked_create_post_button_by_library');
      return;
    }

    this.#scheduleEmptyPost();
    this.#trackSchedulingPost();
  }

  @action
  onDragStart(dragEvent: DragEvent): void {
    this.args.onDragStart(dragEvent);

    const dragImage = document.createElement('div');
    dragImage.innerHTML = `${this.intl.t('calendar.side_library.create_post')}${this.mediaAddSvg}`;
    dragImage.id = 'cLIB--createPostBtn__dragged';
    document.body.appendChild(dragImage); // HTML drag and drop spec requires node to be visible on page

    dragEvent.dataTransfer?.setDragImage(dragImage, 24, 24);
  }

  @action
  onDragEnd(dragEvent: DragEvent): void {
    const copiedElementContainer = document.getElementById('cLIB--createPostBtn__dragged');
    copiedElementContainer?.remove();
    this.args.onDragEnd(dragEvent);
    if (this.dragImage) {
      document.body.removeChild(this.dragImage);
    }
  }

  #trackSchedulingPost(): void {
    this.segment.track('started-scheduling-post', {
      area: 'clicked_create_post_button_by_library',
      type: 'empty_post',
      is_multi_profile: this.socialProfilesSelectedForScheduling.length > 1,
      multi_profile_types: this.socialProfilesSelectedForScheduling,
      number_of_images: 0,
      number_of_videos: 0
    });
  }

  #scheduleEmptyPost(): void {
    const isListView = this.router.currentRouteName?.includes('list');
    const singleOrMultiPost =
      this.selectedSocialProfiles.profiles.length > 1 ? ProfilePostType.Multi : ProfilePostType.Single;

    const targetURL = isListView
      ? `cluster.schedule.list.post.${singleOrMultiPost}`
      : `cluster.schedule.calendar.post.${singleOrMultiPost}`;

    this.router.transitionTo(targetURL, TEXT_POST_TYPE, {
      queryParams: {
        backTo: isListView ? 'cluster.schedule.list' : 'cluster.schedule.calendar',
        scheduledTime: moment().unix()
      }
    });
  }
}
